import React, { useRef } from "react";
import { FaRegCopyright } from "react-icons/fa";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import SplitText from "./SplitText";
import { Typography } from "antd";
import { FaGithub } from "react-icons/fa";

gsap.registerPlugin(useGSAP);

type CopyRightProps = {
  onAnimationComplete?: () => void;
  className?: string;
};

const CopyRight: React.FC<CopyRightProps> = ({ onAnimationComplete, className = "" }) => {
  const Text = Typography;
  const iconRef = useRef<HTMLSpanElement | null>(null);

  useGSAP(() => {
    if (!iconRef.current) return;
    gsap.fromTo(
      iconRef.current,
      { opacity: 0, y: 14 },
      { opacity: 1, y: 0, duration: 0.9, ease: "power3.out" }
    );
  }, []);

  return (
    <div className={`flex flex-col items-center mt-2 ${className}`}>
      <div className="flex items-center gap-1">
      <span ref={iconRef} className="text-white inline-flex items-center">
        {React.createElement(FaRegCopyright as any)}
      </span>

  
        <SplitText
          text="Created By Gil Etzioni"
          className="text-white text-center"
          delay={35}
          duration={0.9}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 14 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="center"
          onLetterAnimationComplete={onAnimationComplete}
          showCallback
          tag="span"
        />
      </div>
      <Text
        className="group !text-white/70 mt-1 flex items-center gap-2 cursor-pointer hover:!text-white"
        onClick={() =>
            window.open(
            "https://",
            "_blank",
            "noopener,noreferrer"
            )
        }
        >

      <span className="inline-flex items-center">
        {React.createElement(FaGithub as any, {
          className: "text-white/70 group-hover:text-white",
        })}
      </span>
      Github

    </Text>
 
</div>
  );  
};

export default CopyRight;